<script>
    import CenterThis from "./CenterThis.svelte";
    import Toggle from "./Toggle.svelte";
    import InputBox from "./InputBox.svelte";
    export let phoneStore;
    export let enabledStore;
    export let inputId;

    function tfaChange(isActive) {
        $enabledStore = isActive;
    }

</script>

<style>

    .toggle-header {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .tfa-container {
        margin: 40px auto 12px auto;
        max-width: 704px;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .highlighted {
        margin: 24px auto 8px auto;
    }

</style>

<CenterThis>
    <div class="tfa-container">
        <div class="toggle-header">
            <h2>2-Factor Verification</h2>
            <Toggle onChange={tfaChange}/>
        </div>
        {#if $enabledStore}
        <p class="small"><strong>Enter the recipient’s mobile phone number below.</strong><br/>
            They will be required to enter a verification code sent to this number before they can view the
            message.</p>
        <InputBox required={true} min={12} inputId={inputId} mask="000-000-0000" placeholder="555-555-5555" store={phoneStore}/>
        <p class="small">(Currently supported only in the U.S and Canada)</p>
        {/if}
    </div>
</CenterThis>
